if (!$.cookie('olive-oil-surveyQuestionBanner') && typeof originalUtmContent !== 'undefined') {
    function showSurveyBanner() {
        $("#surveyQuestionBanner").removeClass('surveyQuestionBanner--hidden');
    }

    function updateFooterPadding() {
        const targetPadding = parseInt($('footer').css('padding-bottom')) + $("#surveyQuestionBanner").outerHeight();
        // console.log('target padding is', targetPadding);
        $('footer').css('padding-bottom', targetPadding);
    }

    if ($('.surveyQuestionBanner--bottom').length) {
        let bannerShown = false;
        const timeout = setTimeout(function(){
            showSurveyBanner();
            setTimeout(updateFooterPadding, 1000); //- waiting for the banner to show up
            bannerShown = true;
        }, secondsToWait * 1000);
    
        $( window ).on('resize', function() {
            setTimeout(function () {
                updateFooterPadding();
            }, 1000);
        });

        if (showOnScroll == true) {
            const viewportHeight = $(window).height();

            $(window).on('scroll', function() {
                clearTimeout(timeout);
                let scrollPosition = $(window).scrollTop();              
               
                if (!bannerShown && scrollPosition > viewportHeight) {
                    showSurveyBanner();
                    bannerShown = true;
                }
            });
        }
    } else {
        showSurveyBanner();
    }

    const utmContentParts = originalUtmContent.split('-opt_');
    $('.surveyQuestionBanner [data-question]').each(function(){
        $(this).on("click", function(){
            // get new utm_ontent sting
            const newUtmContent = utmContentParts[0] + $(this).data().question + '-opt_' + utmContentParts[1];
            
            //update utm_content on cta button
            $('.btn.cta').each(function(index){
                const currentTargetPrefix = $(this).attr('data-param').split('utm_content=')[0];
                $(this).attr('data-param', `${currentTargetPrefix}utm_content=${newUtmContent}`);
                const currentTargetLinkPrefix = $(this).attr('href').split('utm_content=')[0];
                $(this).attr('href', `${currentTargetLinkPrefix}utm_content=${newUtmContent}`);
            });

            //hide banner if close btn clicked and display thanks message instead of title and buttons otherwise
            if ($(this).attr("data-question") == "AX") {
                $('.surveyQuestionBanner__content').fadeOut('normal', function(){
                    $('.surveyQuestionBanner').addClass('surveyQuestionBanner--hidden');
                })
            } else {
                $('.surveyQuestionBanner__content').fadeOut('normal', function(){
                    $('.surveyQuestionBanner').addClass('surveyQuestionBanner--thanks');
                    setTimeout(function(){
                        $('.surveyQuestionBanner').addClass('surveyQuestionBanner--hidden');
                    }, 2000)
                })
            }           
        });
    });
    $.cookie("olive-oil-surveyQuestionBanner", 1, {
        expires: 7
    });
}

